var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import logger from './logger';
/**
 * Sends feedback metadata to JaaS endpoints.
 *
 * @param {string} url - The JaaS metadata endpoint URL.
 * @param {Object} feedbackData - The feedback data object.
 * @returns {Promise}
 */
export function sendFeedbackToJaaSRequest(url, feedbackData) {
    return __awaiter(this, void 0, void 0, function* () {
        const { jwt, sessionId, meetingFqn, score, message, userId, tenant } = feedbackData;
        const headers = {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json'
        };
        const data = {
            sessionId,
            meetingFqn,
            userId,
            tenant,
            submitted: new Date().getTime(),
            rating: score,
            comments: message
        };
        try {
            const res = yield fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            if (!res.ok) {
                logger.error('Status error:', res.status);
            }
        }
        catch (err) {
            logger.error('Could not send request', err);
        }
    });
}
